import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import { Box, Typography } from '@mui/material';
import { FC } from 'react';

const RecaptchaNotice: FC = () => (
  <Box
    className="captcha-note"
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 0.5,
      mt: 1.5,
    }}>
    <ShieldOutlinedIcon sx={{ fontSize: '0.875rem', color: '#94a3b8' }} />
    <Typography variant="caption" sx={{ color: '#94a3b8', fontSize: '0.75rem' }}>
      Protected by reCAPTCHA
    </Typography>
  </Box>
);

export default RecaptchaNotice;
